export const INACTIVE_PATIENT_LIST = "INACTIVE_PATIENT_LIST";
export const SET_TOTAL_COUNT = "SET_TOTAL_COUNT";

export const setInactivePatients = (object) => {
   return {
      type: INACTIVE_PATIENT_LIST,
      payload: object,
   };
};
export const setTotalCount = (object) => {
   return {
      type: SET_TOTAL_COUNT,
      payload: object,
   };
};
